// NotesContext — estado y handlers de las notas compartidas del evento.
// Aislado del MainAppContext (Fase 3 — Paso 4, Feb 2026).
import { createContext, useContext } from "react";

export const NotesContext = createContext(null);

export const useNotes = () => {
  const ctx = useContext(NotesContext);
  if (ctx === null) {
    throw new Error("useNotes debe usarse dentro de <NotesContext.Provider>");
  }
  return ctx;
};
